export enum PreAuthorizedCharges {
    Authorized = 1,
    NotifyBefore = 2,
}
